import React, { FC, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from "react-router-dom";
import toast, { Toaster } from 'react-hot-toast';

import clsx from 'clsx';

import { AppDispatch } from '../../../redux/reducer/store';
import {
  actionGetVacancies,
} from '../../../redux/action/recruiting/actionVacancy';
import {
  reducerSelectedVacanciesId,
  reducerVacancyStatus,
  reducerVacancyListInputValues,
  reducerVacancyMultiselect,
  reducerGetProject,
  reducerGetVacancyList
} from '../../../redux/reducer/recruiting/reducers/reducerVacancy';
import { reducerSelectedEmployeesId } from '../../../redux/reducer/employees/reducers/employeesList';
import { generateStyles } from '../../../utils/generateToastStyles';

import { formatDateWithDots } from '../../../utils/formatDate';
import { formatReports } from '../../../utils/formatReports';

import Loader from '../../custom/loader/loader';
import CustomMultiSelect from '../../custom/customMultiSelect/customMultiSelect';
import Select from '../../custom/select/select';
import RangeDatePicker from '../../custom/rangeDatePicker/rangeDatePicker';
import Pagination from '../../pagination/pagination';
import LimitSelect from '../../custom/limitSelect/limitSelect';
import ToastPopup from '../../custom/toastPopup/toastPopup';

import '../table.scss';
import styles from './employees.module.scss';
import { IUserOptions } from '../../../types/interfaces';
import { actionGetEmployeesList } from '../../../redux/action/employees/actionEmployeesList';

const IS_VISIBLE_SIDEBAR = process.env.REACT_APP_IS_VISIBLE_SIDEBAR;

const booleanOptions = [
  { value: 'all', label: 'Все' },
  { value: 'yes', label: 'Да' },
  { value: 'no', label: 'Нет' },
];

const verifiedOptions = [
  { value: 'all', label: 'Все' },
  { value: 'yes', label: 'Да' },
  { value: 'no', label: 'Нет' },
  { value: 'waiting', label: 'Ожидает' },
];

const exampleEmployee = [{
  id: 1,
  name: 'Иванов Виктор Петрович',
  login: '',
  role: '',
  position: '',
  route: [2],
  freelancer: false,
  project: '',
  areas: 'Московская',
  service: '',
  vsv: '',
  phone: '999 888 77 66',
  registrationDate: '2024-03-19T18:02:41.244546',
  startDate: '2024-03-19T18:02:41.244546',
  createDate: '2024-03-19T18:02:41.244546',
  verified: true,
}];

const TableCurrentEmployees: FC = () => {
  const dispatch: any = useDispatch<AppDispatch>();
  const { id } = useParams<{ id: string }>();

  const {
    data,
    limit,
    page,
    count,
    selectedVacanciesId,
    clientsStatus,
    clientsStatusMessage,
    vacancyListInputValues,
    modifiedDate,
    createDate,
    filters,
  } =
    useSelector((state: any) => state.recruiting.vacancyList);
  const { employeesListSettings, checkboxes } = useSelector((state: any) => state.employees.employeesList);
  const { isOpenSidebar } = useSelector((state: IUserOptions) => state.user.user);
  const { claims } = useSelector((state: IUserOptions) => state.user.user.data);
  const requestStatusOptions = [
    {
      status: 400,
      errorMessage: clientsStatusMessage,
    },
    {
      status: 200,
      successMessage: 'Сотрудник создан!',
    },
    {
      status: 500,
      errorMessage: 'Ошибка на стороне сервера',
    }
  ];
  const [isHeaderCheckboxChecked, setIsHeaderCheckboxChecked] =
    useState<boolean>(false);
  const [isCheckedRows, setIsCheckedRows] = useState<boolean[]>(checkboxes);
  const [currentPage, setCurrentPage] = useState<number>(1);
  const [startPage, setStartPage] = useState<number>(1);
  const [isInputChange, setIsInputChange] = useState<boolean>(false);
  const [isPending, setIsPending] = useState<boolean>(false);

  const actualLimit =
    JSON.parse(localStorage.getItem('pageLimit') as string) || limit;
  const detectedBasename = window.location.pathname.startsWith('/react')
    ? '/react'
    : '';
  useEffect(() => {
    if (selectedVacanciesId && !selectedVacanciesId.length) {
      setIsCheckedRows(data && checkboxes);
      setIsHeaderCheckboxChecked(false);
    }
  }, [checkboxes, data, selectedVacanciesId]);

  useEffect(() => {
    if (data) {
      const updatedCheckedRows =
        data &&
        data.reduce((acc: any, vacancy: any) => {
          const vacancyId = vacancy.vacancy.value?.id;
          acc[vacancyId] = false;
          return acc;
        }, {});
      dispatch(reducerSelectedVacanciesId(formatReports(updatedCheckedRows)));
      setIsCheckedRows(updatedCheckedRows);
    }
  }, [dispatch, data]);

  const handleHeaderCheckboxChange = () => {
    setIsHeaderCheckboxChecked(!isHeaderCheckboxChecked);
  };
  const handleRowCheckboxChange = (id: number) => {
    const employeeId = id;
    setIsCheckedRows((prevCheckedRows: boolean[]) => ({
      ...prevCheckedRows,
      [employeeId]: !prevCheckedRows[employeeId],
    }));
    const updatedSelectedEmployees = formatReports({
      ...isCheckedRows,
      [employeeId]: !isCheckedRows[employeeId],
    });
    dispatch(reducerSelectedEmployeesId(updatedSelectedEmployees));
    if (updatedSelectedEmployees.length === exampleEmployee.length) {
      setIsHeaderCheckboxChecked(true);
    } else {
      setIsHeaderCheckboxChecked(false);
    }
  };

  const handleInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = event.target;
    if (value === '') {
      const updatedInputValues = { ...vacancyListInputValues };
      if (name === 'id') {
        delete updatedInputValues.vacancy;
      } else {
        delete updatedInputValues[name];
      }
      dispatch(reducerVacancyListInputValues(updatedInputValues));
    } else {
      dispatch(
        reducerVacancyListInputValues({
          ...vacancyListInputValues,
          ...(name === 'routes' ? { [name]: [value] } : name === 'id' ? { vacancy: [{ id: value }] } : { [name]: value })
        })
      );
    }
    setIsInputChange(true);
  };
  const handleKeyPress = (event: React.KeyboardEvent<HTMLInputElement>) => {
    if (event.key === 'Enter') {
      setIsInputChange(false);
      resetPages();
    }
  };
  const selectChange = (event: { value: string, label: string }, name: string) => {
    if (event.value === '') {
      const updatedInputValues = { ...vacancyListInputValues };
      delete updatedInputValues[name];
      dispatch(reducerVacancyListInputValues(updatedInputValues));
    } else {
      dispatch(
        reducerVacancyListInputValues({
          ...vacancyListInputValues,
          [name]: event.value === 'all' ? null : event.value === 'yes',
        })
      )
      setIsInputChange(true);
    }
  };
  const handleChange = (newLimit: number, newPage: number) => {
    localStorage.setItem('pageLimit', JSON.stringify(newLimit));
  };

  const resetPages = () => {
    setCurrentPage(1);
    setStartPage(1);
  };
  const handleChangeLimits = (option: { value: number }) => {
    handleChange(option.value, 1);
    resetPages();
  };

  useEffect(() => {
    requestStatusOptions.forEach((option: any) => {
      if (clientsStatus === option.status) {
        toast.dismiss();
        toast(
          t => (
            <ToastPopup
              title={
                option.successMessage
                  ? option.successMessage
                  : option.errorMessage
              }
              isSuccess={option.successMessage ? true : false}
              toast={toast}
              t={t}
            />
          ),
          generateStyles(option.successMessage ? true : false)
        );
      }
    });
    setTimeout(() => {
      dispatch(reducerVacancyStatus(null));
    }, 5000);
    // eslint-disable-next-line
  }, [dispatch, clientsStatus]);

  useEffect(() => {
    const handleDocumentClick = (event: any) => {
      const touchedInputs = ['salary', 'revenue'];
      if (!touchedInputs.includes(event.target.name) && isInputChange) {
        setIsInputChange(false);
        resetPages();
      }
    };
    if (isInputChange) {
      document.addEventListener('click', handleDocumentClick);
      return () => {
        document.removeEventListener('click', handleDocumentClick);
      };
    } else
      return () => {
        document.removeEventListener('click', handleDocumentClick);
      };
  }, [dispatch, isInputChange, limit, page]);

  useEffect(() => {
    dispatch(reducerGetProject(id ? [{ id: id }] : null));
  }, [id, dispatch]);

  useEffect(() => {
    dispatch(reducerGetVacancyList({ data: [] }));
    dispatch(actionGetEmployeesList(0, 50))
  }, [dispatch])
  return (
    <>
      <div className='loader__wrapper'>
        {(isPending) && <Loader />}
      </div>

      <div
        className={clsx(
          JSON.parse(IS_VISIBLE_SIDEBAR as string) &&
          isOpenSidebar &&
          'active__table',
          !isOpenSidebar && 'closed__table',
          'table'
        )}
      >
        {(clientsStatus && clientsStatus !== null) && <Toaster
          position='top-center'
          toastOptions={{
            duration: 5000,
          }}
        />}
        <div className='table__wrapper'>
          <table>
            <thead className='table__header'>
              <tr>
                <th className='reports__checkbox_block'>
                  {(claims.includes('admin') || claims.includes('recruiting:vacancy:export') || claims.includes('recruiting:vacancy:edit')) &&
                    <input
                      onChange={handleHeaderCheckboxChange}
                      type='checkbox'
                    />}
                </th>

                {employeesListSettings.includes('name') && <th style={{ minWidth: '280px' }}>
                  <div className='filter__block'>
                    <input
                      onChange={handleInputChange}
                      onKeyPress={handleKeyPress}
                      autoComplete='off'
                      placeholder=' '
                      name='name'
                      type='text'
                    />
                    <label>ФИО</label>
                  </div>
                </th>}

                {employeesListSettings.includes('login') && <th style={{ minWidth: '280px' }}>
                  <div className='filter__block'>
                    <input
                      onChange={handleInputChange}
                      onKeyPress={handleKeyPress}
                      autoComplete='off'
                      placeholder=' '
                      name='login'
                      type='text'
                    />
                    <label>Логин</label>
                  </div>
                </th>}

                {employeesListSettings.includes('role') && <th>
                  <div className='multiselect__filter_block'>
                    <CustomMultiSelect
                      setLoading={setIsPending}
                      inputValues={[]}
                      options={filters.types}
                      isShowPlaceholder={true}
                      pageName='userReports'
                      placeholder='Роль'
                      name='role'
                      limit={limit}
                      reducer={reducerVacancyMultiselect}
                      resetPages={() => { }}
                      action={actionGetVacancies}
                    />
                  </div>
                </th>}

                {employeesListSettings.includes('position') && <th>
                  <div className='multiselect__filter_block'>
                    <CustomMultiSelect
                      setLoading={setIsPending}
                      inputValues={[]}
                      options={filters.types}
                      isShowPlaceholder={true}
                      pageName='userReports'
                      placeholder='Должность'
                      name='position'
                      limit={limit}
                      reducer={reducerVacancyMultiselect}
                      resetPages={() => { }}
                      action={actionGetVacancies}
                    />
                  </div>
                </th>}

                {employeesListSettings.includes('hasroute') && <th>
                  <div
                    className={clsx('filter__number_block', styles.checkin)}
                  >
                    <Select
                      options={booleanOptions}
                      propsChange={(event: { value: string, label: string }) =>
                        selectChange(event, "hasroute")
                      }
                      placeholder='Наличие маршрута'
                      className='users__filter'
                      name="hasroute"
                    />
                  </div>
                </th>}

                {employeesListSettings.includes('freelancer') && <th>
                  <div
                    className={clsx('filter__number_block', styles.checkin)}
                  >
                    <Select
                      options={booleanOptions}
                      propsChange={(event: { value: string, label: string }) =>
                        selectChange(event, "hasUrl")
                      }
                      placeholder='Фрилансер'
                      className='users__filter'
                      name="freelancer"
                    />
                  </div>
                </th>}

                {employeesListSettings.includes('project') && <th>
                  <div className='multiselect__filter_block'>
                    <CustomMultiSelect
                      setLoading={setIsPending}
                      inputValues={[]}
                      options={filters.types}
                      isShowPlaceholder={true}
                      pageName='userReports'
                      placeholder='Проект'
                      name='project'
                      limit={limit}
                      reducer={reducerVacancyMultiselect}
                      resetPages={() => { }}
                      action={actionGetVacancies}
                    />
                  </div>
                </th>}

                {employeesListSettings.includes('areas') && <th>
                  <div
                    className={clsx('filter__number_block', styles.checkin)}
                  >
                    <Select
                      options={[]}
                      propsChange={(event: { value: string, label: string }) =>
                        selectChange(event, "areas")
                      }
                      placeholder='Область'
                      className='users__filter'
                      name='areas'
                    />
                  </div>
                </th>}

                {employeesListSettings.includes('service') && <th>
                  <div
                    className={clsx('filter__number_block', styles.checkin)}
                  >
                    <Select
                      options={[]}
                      propsChange={(event: { value: string, label: string }) =>
                        selectChange(event, "service")
                      }
                      placeholder='Служба'
                      className='users__filter'
                      name='service'
                    />
                  </div>
                </th>}

                {employeesListSettings.includes('vsv') && <th>
                  <div className='multiselect__filter_block'>
                    <CustomMultiSelect
                      setLoading={setIsPending}
                      inputValues={[]}
                      options={filters.virtualSupervisors}
                      isShowPlaceholder={true}
                      pageName='userReports'
                      placeholder='ВСВ'
                      name='vsv'
                      limit={limit}
                      resetPages={() => { }}
                      reducer={reducerVacancyMultiselect}
                      action={actionGetVacancies}
                    />
                  </div>
                </th>}

                {employeesListSettings.includes('phone') && <th style={{ minWidth: '180px' }}>
                  <div className='filter__block'>
                    <input
                      onChange={handleInputChange}
                      onKeyPress={handleKeyPress}
                      autoComplete='off'
                      placeholder=' '
                      name='phone'
                      type='text'
                    />
                    <label>Телефон</label>
                  </div>
                </th>}

                {employeesListSettings.includes('registrationDate') && <th style={{ minWidth: '140px' }}>
                  <RangeDatePicker
                    setLoading={setIsPending}
                    reducer={reducerVacancyListInputValues}
                    defaultDateFrom={createDate.formattedDateFrom}
                    inputValues={vacancyListInputValues}
                    defaultDateTo={createDate.formattedDateTo}
                    setCurrentPage={setCurrentPage}
                    action={() => { }}
                    setStartPage={setStartPage}
                    limit={limit}
                    page={page}
                    placeholder='Дата оформления'
                    pageName='vacancyList'
                    name='registrationDate'
                  />
                </th>}

                {employeesListSettings.includes('startDate') && <th style={{ minWidth: '140px' }}>
                  <RangeDatePicker
                    setLoading={setIsPending}
                    reducer={reducerVacancyListInputValues}
                    defaultDateFrom={modifiedDate.formattedDateFrom}
                    inputValues={vacancyListInputValues}
                    defaultDateTo={modifiedDate.formattedDateTo}
                    setCurrentPage={setCurrentPage}
                    action={() => { }}
                    setStartPage={setStartPage}
                    limit={limit}
                    page={page}
                    placeholder='Дата начала работы'
                    pageName='staffList'
                    name='startDate'
                  />
                </th>}

                {employeesListSettings.includes('createDate') && <th style={{ minWidth: '140px' }}>
                  <RangeDatePicker
                    setLoading={setIsPending}
                    reducer={reducerVacancyListInputValues}
                    defaultDateFrom={modifiedDate.formattedDateFrom}
                    inputValues={vacancyListInputValues}
                    defaultDateTo={modifiedDate.formattedDateTo}
                    setCurrentPage={setCurrentPage}
                    action={() => { }}
                    setStartPage={setStartPage}
                    limit={limit}
                    page={page}
                    placeholder='Дата создания'
                    pageName='vacancyList'
                    name='createDate'
                  />
                </th>}

                {employeesListSettings.includes('verified') && <th>
                  <div
                    className={clsx('filter__number_block', styles.checkin)}
                  >
                    <Select
                      options={verifiedOptions}
                      propsChange={(event: { value: string, label: string }) =>
                        selectChange(event, "verified")
                      }
                      placeholder='Верифицирован'
                      className='users__filter'
                      name='verified'
                    />
                  </div>
                </th>}
              </tr>
            </thead>

            <tbody>
              {exampleEmployee.map((el: any, index: number) => {
                return (
                  <tr className='active__link_tr' key={index}>
                    <td>
                      {(claims.includes('admin') || claims.includes('recruiting:vacancy:export') || claims.includes('recruiting:vacancy:edit')) &&
                        <input
                          onChange={() => handleRowCheckboxChange(el.id)}
                          checked={(isCheckedRows && isCheckedRows[el.id]) || false
                          }
                          className='relative__elem'
                          type='checkbox'
                        />}
                    </td>
                    {employeesListSettings.includes('name') && <td>
                      <span className={styles.relative__elem}>
                        {el?.name}
                      </span>
                    </td>}

                    {employeesListSettings.includes('login') && <td>
                      <span className={styles.relative__elem}>
                        {el?.login}
                      </span>
                    </td>}

                    {employeesListSettings.includes('role') && <td>
                      <span className={styles.relative__elem}>
                        {el?.role}
                      </span>
                    </td>}

                    {employeesListSettings.includes('position') && <td>
                      <span className={styles.relative__elem}>
                        {el?.position}
                      </span>
                    </td>}

                    {employeesListSettings.includes('hasroute') && <td>
                      <span className={styles.relative__elem}>
                        {el?.route?.length > 0 ? 'Да' : 'Нет'}
                      </span>
                    </td>}

                    {employeesListSettings.includes('freelancer') && <td>
                      <span className={styles.relative__elem}>
                        {el?.freelancer ? 'Да' : 'Нет'}
                      </span>
                    </td>}

                    {employeesListSettings.includes('project') && <td>
                      <span className={styles.relative__elem}>
                        {el?.project}
                      </span>
                    </td>}

                    {employeesListSettings.includes('areas') && <td>
                      <span className={styles.relative__elem}>
                        {el?.areas}
                      </span>
                    </td>}

                    {employeesListSettings.includes('service') && <td>
                      <span className={styles.relative__elem}>
                        {el?.service}
                      </span>
                    </td>}

                    {employeesListSettings.includes('vsv') && <td>
                      <span className={styles.relative__elem}>
                        {el?.vsv}
                      </span>
                    </td>}


                    {employeesListSettings.includes('phone') && <td>
                      <span className={styles.relative__elem}>{el?.phone}</span>
                    </td>}

                    {employeesListSettings.includes('registrationDate') && <td>
                      <span className={styles.relative__elem}>
                        {formatDateWithDots(el?.registrationDate)}
                      </span>
                    </td>}

                    {employeesListSettings.includes('startDate') && <td>
                      <span className={styles.relative__elem}>
                        {formatDateWithDots(el?.startDate)}
                      </span>
                    </td>}

                    {employeesListSettings.includes('createDate') && <td>
                      <span className={styles.relative__elem}>
                        {formatDateWithDots(el?.createDate)}
                      </span>
                    </td>}

                    {employeesListSettings.includes('verified') && <td>
                      <span className={styles.relative__elem}>
                        {el?.verified ? 'Да' : 'Нет'}
                      </span>
                    </td>}

                    <td className='invisible__reports_cell'>
                      <a
                        href={`${detectedBasename}/employees/profile/${el?.id}`}
                        className='link__tr'
                        draggable='false'
                        rel='noreferrer'
                        target='_blank'
                      >
                        {' '}
                      </a>
                    </td>
                  </tr>
                )
              })}
            </tbody>
          </table>
        </div>

        <div className='pagination'>
          <div className='pagination__count'>Всего: {count}</div>
          <div className='pagination__str'>
            <span>Отображать строки</span>
            <LimitSelect limit={actualLimit} propsChange={handleChangeLimits} />
          </div>
          <Pagination
            setCurrentPage={setCurrentPage}
            setStartPage={setStartPage}
            handleChange={handleChange}
            count={count}
            currentPage={currentPage}
            startPage={startPage}
            limit={actualLimit}
            pageName='userReports'
          />
        </div>
      </div>
    </>
  );
};

export default TableCurrentEmployees;